import { Injectable } from '@angular/core';
import * as SecureLS from 'secure-ls';
import { environment } from '../../environments/environment';

const ls = new SecureLS({ encodingType: 'rc4', isCompression: false, encryptionSecret: environment.LS_SECRET });

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  prefix = 'allya-state-';

  set(key: string, value: any): void {
    ls.set(`${this.prefix}${key}`, value);
  }

  get(key): any {
    return ls.get(`${this.prefix}${key}`);
  }

  remove(key): void {
    ls.remove(`${this.prefix}${key}`);
  }

  clear(): void {
    Object.keys(localStorage)
      .filter(key => key.indexOf(this.prefix) === 0)
      .map(key => ls.remove(key));
  }

  removeExternal(key: string): void {
    localStorage.removeItem(key);
  }

}
